import { render, staticRenderFns } from "./AxReleaseHistory.vue?vue&type=template&id=fabe9158&scoped=true&"
import script from "./AxReleaseHistory.vue?vue&type=script&lang=ts&"
export * from "./AxReleaseHistory.vue?vue&type=script&lang=ts&"
import style0 from "./AxReleaseHistory.vue?vue&type=style&index=0&id=fabe9158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe9158",
  null
  
)

export default component.exports